import { Injectable, signal } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class ClassManagerApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }

  readonly classHierarchy = signal<any>(null)

  classGetHierarchyList (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/classManager/hierarchyList`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  loadHierarchy (): Observable<any> {
    return this.classGetHierarchyList().pipe(tap(data => this.classHierarchy.set(data)))
  }

  classGetSuperclassList (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/classManager/superclassList`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  classModify (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/classManager/modify`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  classCreate (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/classManager/create`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  classDelete (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/classManager/delete`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getRecords (ClassName: string): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/records?class=${ClassName}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getrecordAttachment (ClassName: string, Id: number, column: string): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/recordAttachment?classname=${ClassName}&Id=${Id}&column=${column}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getFilterRecords (ClassName: string, FilterId, parameter, value): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/filterRecords?class=${ClassName}&filter_id=${FilterId}&parameter=${parameter}&parameter_value=${value}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getRecord (ClassName: string, Id: number): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/record?class=${ClassName}&Id=${Id}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getRecordHistory (ClassName: string, Id: number): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/recordHistory?class=${ClassName}&Id=${Id}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  createRecord (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/createRecord`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  updateRecord (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/updateRecord`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  updateRecords (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/updateRecords`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  importRecords (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/importRecords`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  updateRecords_multiFields (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/updateRecords_multiFields`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  updateRecordOptions (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/updateRecordOptions`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  deleteRecord (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/deleteRecord`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  deleteRecords (data): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/deleteRecords`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getRowDrillDown (data: any): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/dropdownRecords`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getMultiDropdown (data: any): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/recordManager/multiDropdownRecords`
    return this.http.post(apiEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  createFilter (obj): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/filter/createFilter`
    return this.http.post(apiEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  editFilter (obj): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/filter/editFilter`
    return this.http.post(apiEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  deleteFilter (obj): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/filter/deleteFilter`
    return this.http.post(apiEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getFilterList (ClassName): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/filter/getFilterList?DestinationClass=${ClassName}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getgroups (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/group/list`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getFortigatesToStage (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/stagingGara3/get_Fortigates_ToStage`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getFEXToStage (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/stagingGara3/get_FEX_ToStage`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getSIMToStage (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/stagingGara3/get_SIM_ToStage`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  startTask (obj): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/stagingGara3/start_PreStaging`
    return this.http.post(apiEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  startConfiguration (obj): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/awpSDWAN/start_AnsibleConfig`
    return this.http.post(apiEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }
endConfigurationRTU (obj): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/update_ListRTU`
    return this.http.post(apiEndPoint, obj, this.fuseqHeaders.setRtuApiKeyHeaders('POST'))
}
  getDiscoveryRTUMac (frazionario: string): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/get_discoveryRTUMac/${frazionario}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
  }
  getDiscoveryRTULease (frazionario: string): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/get_discoveryRTULease/${frazionario}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
  }
  postFixAddress (obj): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/post_fixAddress`
    return this.http.post(apiEndPoint, obj, this.fuseqHeaders.setRtuApiKeyHeaders('POST'))
  }
  resetInfoRTU (obj): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/reset_infoRTU`
    return this.http.post(apiEndPoint, obj, this.fuseqHeaders.setRtuApiKeyHeaders('POST'))
  }
getRTU (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/get_RTUpianificati`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
}
getRTUglobal (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/get_RTUglobal`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
}
getRTUByFrazionario (frazionario: string): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/get_RTUByFrazionario/${frazionario}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
}
getRTUStatusOnline (frazionario: string): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/get_RTUStatusOnline/${frazionario}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
}
getRTUPingHistory (frazionario: string, days?: number): Observable<any> {
    const query = days ? `?days=${days}` : ''
    const apiEndPoint = `${environment.API_URL}/rtu/get_RTUPingHistory/${encodeURIComponent(frazionario)}${query}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
}
getRTUPingDashboardStats (days = 7, thresholds?: { slaUptime?: number, warnUptime?: number, flappingMin?: number, degradeSlope?: number }): Observable<any> {
    const params = new URLSearchParams({ days: String(days) })
    if (thresholds?.slaUptime != null) params.set('slaUptime', String(thresholds.slaUptime))
    if (thresholds?.warnUptime != null) params.set('warnUptime', String(thresholds.warnUptime))
    if (thresholds?.flappingMin != null) params.set('flappingMin', String(thresholds.flappingMin))
    if (thresholds?.degradeSlope != null) params.set('degradeSlope', String(thresholds.degradeSlope))
    const apiEndPoint = `${environment.API_URL}/rtu/get_RTUPingDashboardStats?${params.toString()}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
}
getRTUStatusOnlineAll (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/get_RTUStatusOnline`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
}
deleteRTUHistory (frazionari?: string[]): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/delete_RTUHistory`
    return this.http.post(apiEndPoint, { frazionari: frazionari ?? [] }, this.fuseqHeaders.setRtuApiKeyHeaders('POST'))
}
getRTUPingDiagnostics (frazionario: string): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/get_RTUPingDiagnostics/${encodeURIComponent(frazionario)}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
}
getRTUPingDiagnosticsAll (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/get_RTUPingDiagnostics`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
}
  testConnettivitaRTU (obj): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/test_connettivita_RTU`
    return this.http.post(apiEndPoint, obj, this.fuseqHeaders.setRtuApiKeyHeaders('POST'))
  }
  postFuoriPianificazione (obj): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/rtu_Planning`
    return this.http.post(apiEndPoint, obj, this.fuseqHeaders.setRtuApiKeyHeaders('POST'))
}
get_ModelsRTU_Compay (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/get_RTUList`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
}
  getPreStaging (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/stagingGara3/get_Prestaging`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getAnagraficaSiti (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/get_Anagrafica_Siti`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
  }
  closeSegnalazioneRTU (frazionario: string): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/rtu/close_blocking_rtu`
    return this.http.post(apiEndPoint, { fraz: frazionario }, this.fuseqHeaders.setRtuApiKeyHeaders('POST'))
  }
  getRTUHistory (params?: { frazionario?: string, action?: string, outcome?: string, from?: string, to?: string }): Observable<any> {
    const query = new URLSearchParams()
    if (params?.frazionario) query.set('frazionario', params.frazionario)
    if (params?.action) query.set('action', params.action)
    if (params?.outcome) query.set('outcome', params.outcome)
    if (params?.from) query.set('from', params.from)
    if (params?.to) query.set('to', params.to)
    const qs = query.toString()
    const apiEndPoint = `${environment.API_URL}/rtu/get_RTUHistory${qs ? `?${qs}` : ''}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setRtuApiKeyHeaders('GET'))
  }

  // --- Analisi SIM (dove sono finite le SIM di t_sim) ---
  getSimAnalysisSummary (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/simAnalysis/summary`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getSimAnalysisRuns (limit = 30): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/simAnalysis/runs?limit=${limit}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getSimAnalysisSims (params?: {
    esito?: string
    frazionario?: string
    routerTable?: string
    onlyIssues?: boolean
    q?: string
    limit?: number
    offset?: number
  }): Observable<any> {
    const query = new URLSearchParams()
    if (params?.esito) query.set('esito', params.esito)
    if (params?.frazionario) query.set('frazionario', params.frazionario)
    if (params?.routerTable) query.set('routerTable', params.routerTable)
    if (params?.onlyIssues) query.set('onlyIssues', 'true')
    if (params?.q) query.set('q', params.q)
    if (params?.limit != null) query.set('limit', String(params.limit))
    if (params?.offset != null) query.set('offset', String(params.offset))
    const apiEndPoint = `${environment.API_URL}/simAnalysis/sims?${query.toString()}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getSimAnalysisFilters (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/simAnalysis/filters`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getSimAnalysisSim (iccid: string): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/simAnalysis/sim/${encodeURIComponent(iccid)}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getSimAnalysisHistory (params?: { iccid?: string, changeType?: string, from?: string, to?: string, limit?: number, offset?: number }): Observable<any> {
    const query = new URLSearchParams()
    if (params?.iccid) query.set('iccid', params.iccid)
    if (params?.changeType) query.set('changeType', params.changeType)
    if (params?.from) query.set('from', params.from)
    if (params?.to) query.set('to', params.to)
    if (params?.limit != null) query.set('limit', String(params.limit))
    if (params?.offset != null) query.set('offset', String(params.offset))
    const apiEndPoint = `${environment.API_URL}/simAnalysis/history?${query.toString()}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  runSimAnalysis (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/simAnalysis/run`
    return this.http.post(apiEndPoint, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  // --- Configurazioni Cisco SD-WAN (report settimanale + backup running-config) ---
  getCiscoFabricSummary (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/ciscoFabric/summary`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getCiscoFabricFilters (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/ciscoFabric/filters`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getCiscoFabricConfigurations (params?: {
    cella?: string
    frazionario?: string
    esito?: string
    presenza?: string
    onlyProblems?: boolean
    q?: string
    limit?: number
    offset?: number
  }): Observable<any> {
    const query = new URLSearchParams()
    if (params?.cella) query.set('cella', params.cella)
    if (params?.frazionario) query.set('frazionario', params.frazionario)
    if (params?.esito) query.set('esito', params.esito)
    if (params?.presenza) query.set('presenza', params.presenza)
    if (params?.onlyProblems) query.set('onlyProblems', 'true')
    if (params?.q) query.set('q', params.q)
    if (params?.limit != null) query.set('limit', String(params.limit))
    if (params?.offset != null) query.set('offset', String(params.offset))
    const apiEndPoint = `${environment.API_URL}/ciscoFabric/configurations?${query.toString()}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getCiscoFabricConfiguration (id: number): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/ciscoFabric/configurations/${id}`
    return this.http.get(apiEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getCiscoFabricConfigDownload (id: number): Observable<Blob> {
    const apiEndPoint = `${environment.API_URL}/ciscoFabric/configurations/${id}/download`
    return this.http.get(apiEndPoint, { ...this.fuseqHeaders.setTokenHeaders('GET'), responseType: 'blob' })
  }

  getCiscoFabricConfigText (id: number): Observable<string> {
    const apiEndPoint = `${environment.API_URL}/ciscoFabric/configurations/${id}/download?inline=true`
    return this.http.get(apiEndPoint, { ...this.fuseqHeaders.setTokenHeaders('GET'), responseType: 'text' })
  }

  runCiscoFabricFull (): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/ciscoFabric/run`
    return this.http.post(apiEndPoint, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  runCiscoFabricSpot (id: number): Observable<any> {
    const apiEndPoint = `${environment.API_URL}/ciscoFabric/configurations/${id}/run`
    return this.http.post(apiEndPoint, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  /** CSV per l'allineamento manuale (scope: 'toAlign' | 'all'). */
  getSimAnalysisExport (params?: {
    scope?: 'toAlign' | 'all'
    esito?: string
    frazionario?: string
    routerTable?: string
    onlyIssues?: boolean
    q?: string
  }): Observable<Blob> {
    const query = new URLSearchParams()
    if (params?.scope) query.set('scope', params.scope)
    if (params?.esito) query.set('esito', params.esito)
    if (params?.frazionario) query.set('frazionario', params.frazionario)
    if (params?.routerTable) query.set('routerTable', params.routerTable)
    if (params?.onlyIssues) query.set('onlyIssues', 'true')
    if (params?.q) query.set('q', params.q)
    const apiEndPoint = `${environment.API_URL}/simAnalysis/export?${query.toString()}`
    return this.http.get(apiEndPoint, { ...this.fuseqHeaders.setTokenHeaders('GET'), responseType: 'blob' })
  }
}
